import {
    defineStore
} from 'pinia'
import {
    ref
} from 'vue'

export const useLoaderStore = defineStore('loader', () => {
    // Visible dès le démarrage pour couvrir le premier chargement
    const visible = ref(true)
    const progress = ref(0)
    const message = ref('Chargement...')

    let progressTimer = null

    function show(msg = 'Chargement...') {
        message.value = msg
        progress.value = 0
        visible.value = true
        _startProgress()
    }

    function hide() {
        progress.value = 100
        clearInterval(progressTimer)
        setTimeout(() => {
            visible.value = false
            progress.value = 0
        }, 350)
    }

    function _startProgress() {
        clearInterval(progressTimer)
        progressTimer = setInterval(() => {
            if (progress.value < 70) {
                progress.value += Math.random() * 14
            } else if (progress.value < 90) {
                progress.value += Math.random() * 2
            }
            if (progress.value > 90) progress.value = 90
        }, 120)
    }

    // Démarrer la progression immédiatement
    _startProgress()

    return {
        visible,
        progress,
        message,
        show,
        hide
    }
})